import {useMutation, useQueryClient} from "@tanstack/react-query";
import {updateUser} from "@/services/account/account.service";

const normalizeVenezuelanPhone = raw => {
  if (!raw) return "";
  const digits = String(raw).replace(/\D/g, "");
  if (digits.startsWith("58") && digits.length >= 12) return `0${digits.slice(2)}`;
  if (digits.startsWith("0") && digits.length >= 11) return digits;
  if (digits.length === 10) return `0${digits}`;
  return digits;
};

const useUpdateAlias = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: alias => {
      const userData = queryClient.getQueryData(["userData"])?.data?.data;
      const phoneNumber = normalizeVenezuelanPhone(userData?.phoneNumber);
      const nationalID = String(userData?.nationalID || "");

      return updateUser({
        firstName: userData?.given_name || userData?.firstName || "",
        lastName: userData?.family_name || userData?.lastName || "",
        ...(nationalID && {nationalID}),
        ...(phoneNumber && {phoneNumber}),
        alias,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userData"]});
    },
  });

  return {
    updateAlias: mutation.mutate,
    updateAliasAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};

export default useUpdateAlias;
